import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FilterList, StudyFilterService } from '@services';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'filter-menu',
  templateUrl: './filter-menu.component.html',
  styleUrl: './filter-menu.component.scss'
})
export class FilterMenuComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private studyFilterService = inject(StudyFilterService);

  showMenu = false;
  @Input() totalFiltersApplied = 0;
  @Input() columnTitleMappings: Record<string, string> = {};

  @Output() toggleMenuEvent = new EventEmitter<{ event: MouseEvent; column: string }>();
  @Output() closeMenuEvent = new EventEmitter<void>();

  // Get filter state from service
  get filtersApplied(): FilterList {
    return this.studyFilterService.getCurrentState().appliedFilters;
  }

  get filterOptions(): FilterList {
    return this.studyFilterService.getCurrentState().availableOptions;
  }

  ngOnInit() {
    // Subscribe to filter state changes to keep the component reactive
    this.studyFilterService.filterState$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Component will automatically update through getters
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get filtersAppliedArray(): { key: string; value: string[] }[] {
    if (!this.filtersApplied) return [];
    return Object.entries(this.filtersApplied).map(([key, value]) => {
      let arr: string[] = [];
      if (Array.isArray(value)) {
        arr = value;
      } else if (
        value &&
        typeof value === 'object' &&
        typeof (value as any).values === 'function'
      ) {
        arr = Array.from((value as any).values());
      }
      return { key: String(key), value: arr };
    });
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    this.showMenu = !this.showMenu;
  }

  removeFilter(filter: string, column: string) {
    this.studyFilterService.removeFilter(column, filter, 'table');
  }

  clearAllFilters() {
    this.studyFilterService.clearAllFilters('table');
  }

  closeMenu() {
    this.showMenu = false;
  }

  trackByKey(index: number, item: any) {
    return item.key;
  }

  trackByFilter(index: number, item: any) {
    return item;
  }
}
